import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { DecisionCreator } from './DecisionCreator';
import { Alert, AlertDescription } from './ui/alert';
import { createDecision } from '../services/decisions';
import { User } from 'firebase/auth';

interface CreateDecisionPageProps {
  user: User;
  onError?: (error: string) => void;
}

export function CreateDecisionPage({ user, onError }: CreateDecisionPageProps) {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [isCreating, setIsCreating] = useState(false);
  
  // Add effect to scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  // In CreateDecisionPage.tsx, update the onSubmit function:

  const onSubmit = async (data: { question: string; details?: string; visibility?: 'public' | 'unlisted' }) => {
    setError(null);
    setIsCreating(true);
    
    try {
      const decisionId = await createDecision({
        question: data.question,
        details: data.details,
        requiresAuth: false,
        visibility: data.visibility || 'unlisted'
      });
      navigate(`/d/${decisionId}/share`); 
    } catch (err) {
      console.error('Error creating decision:', err);
      setError('Failed to create decision. Please try again.');
    } finally {
      setIsCreating(false);
    }
  };

  return (
    <div className="container mx-auto max-w-3xl px-0 md:px-4">
    {error && (
        <Alert variant="destructive" className="mb-4">
        <AlertDescription>{error}</AlertDescription>
        </Alert>
    )}

    <DecisionCreator 
        onSubmit={onSubmit}
        isSubmitting={isCreating}
        user={user}
        onError={onError}
    />
    </div>
  );
}